module.exports = "<div class=\"navbar\" id=\"promo-bar\" ng-show=\"showPromoBar()\" ng-class=\"promo.src\">\n  <div class=\"row\">\n    <div class=\"col-sm-3 col-sm-push-9\">\n      <a class=\"cta\" ng-show=\"promo.link\" href=\"{{ promo.link.url }}\">{{ promo.link.text }}</a>\n      <div class=\"close\" ng-click=\"dismissed = true\"><i class=\"fa fa-close\"></i></div>\n    </div>\n    <div class=\"col-sm-9 col-sm-pull-3\">\n      <h3 ng-bind-html=\"promo.message\"></h3>\n    </div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/directives/promoBar/template.html
// module id = 860
// module chunks = 1